import(/* webpackMode: "eager" */ "/home/aries/adlily/apps/v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/aries/adlily/apps/v2/src/app/icon.png");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/home/aries/adlily/apps/v2/src/components/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/aries/adlily/apps/v2/src/components/button.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleTrigger","Collapsible","CollapsibleContent"] */ "/home/aries/adlily/apps/v2/src/components/collapsible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Credenza","CredenzaContent","CredenzaHeader","CredenzaTitle","CredenzaDescription","CredenzaFooter","CredenzaClose"] */ "/home/aries/adlily/apps/v2/src/components/credenza.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuContent","DropdownMenuLabel","DropdownMenuSeparator"] */ "/home/aries/adlily/apps/v2/src/components/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationSelect"] */ "/home/aries/adlily/apps/v2/src/components/navigation/organization-select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutItem"] */ "/home/aries/adlily/apps/v2/src/components/navigation/user/log-out.tsx");
;
import(/* webpackMode: "eager" */ "/home/aries/adlily/apps/v2/src/components/sidebar.tsx");
